import { getCurrentYear } from './helpers';

export const LANGUAGES = ['en', 'de', 'es', 'ja', 'ru', 'it', 'fr'];

export const COPYRIGHT = `© ${getCurrentYear()} Carista.`;

export const BREAKPOINT_MOBILE = 1030;

export const SOCIALS_LINK_FACEBOOK = 'https://www.facebook.com/caristaapp';
export const SOCIALS_LINK_FACEBOOK_GROUP = 'https://www.facebook.com/groups/caristausers/?ref=share';
export const SOCIALS_LINK_LINKEDIN =
    'https://www.linkedin.com/company/carista/';
export const SOCIALS_LINK_INSTAGRAM = 'https://www.instagram.com/caristaapp/';
export const SOCIALS_LINK_TIKTOK = 'https://www.tiktok.com/@caristaapp';
export const SOCIALS_LINK_YOUTUBE =
    'https://www.youtube.com/channel/UCeiMZzmLpzhH1qcZ-tezXmA';

export const VAG_MAKES = ['Audi', 'Volkswagen', 'Seat', 'Skoda', 'Cupra'];
export const ALL_MAKES = [
    'audi',
    'bmw',
    'cupra',
    'ford',
    'infiniti',
    'jaguar',
    'land-rover',
    'lexus',
    'lincoln',
    'man',
    'mazda',
    'mini',
    'nissan',
    'scion',
    'seat',
    'skoda',
    'toyota',
    'volvo',
    'vw',
];

export const BRAND_LOGOS = {
    audi: () => import('@/assets/icons/car-logos/AudiLogo.vue'),
    bmw: () => import('@/assets/icons/car-logos/BMWLogo.vue'),
    buick: () => import('@/assets/icons/car-logos/BuickLogo.vue'),
    cadillac: () => import('@/assets/icons/car-logos/CadillacLogo.vue'),
    chevrolet: () => import('@/assets/icons/car-logos/ChevroletLogo.vue'),
    cupra: () => import('@/assets/icons/car-logos/CupraLogo.vue'),
    ford: () => import('@/assets/icons/car-logos/FordLogo.vue'),
    gmc: () => import('@/assets/icons/car-logos/GMCLogo.vue'),
    holden: () => import('@/assets/icons/car-logos/HoldenLogo.vue'),
    hummer: () => import('@/assets/icons/car-logos/HummerLogo.vue'),
    infiniti: () => import('@/assets/icons/car-logos/InfinitiLogo.vue'),
    jaguar: () => import('@/assets/icons/car-logos/JaguarLogo.vue'),
    'land-rover': () => import('@/assets/icons/car-logos/LandRoverLogo.vue'),
    lexus: () => import('@/assets/icons/car-logos/LexusLogo.vue'),
    lincoln: () => import('@/assets/icons/car-logos/LincolnLogo.vue'),
    man: () => import('@/assets/icons/car-logos/MANLogo.vue'),
    mazda: () => import('@/assets/icons/car-logos/MazdaLogo.vue'),
    mini: () => import('@/assets/icons/car-logos/MiniLogo.vue'),
    nissan: () => import('@/assets/icons/car-logos/NissanLogo.vue'),
    opelvauxhall: () => import('@/assets/icons/car-logos/OpelVauxhallLogo.vue'),
    saab: () => import('@/assets/icons/car-logos/SaabLogo.vue'),
    scion: () => import('@/assets/icons/car-logos/ScionLogo.vue'),
    seat: () => import('@/assets/icons/car-logos/SEATLogo.vue'),
    skoda: () => import('@/assets/icons/car-logos/SkodaLogo.vue'),
    toyota: () => import('@/assets/icons/car-logos/ToyotaLogo.vue'),
    volvo: () => import('@/assets/icons/car-logos/VolvoLogo.vue'),
    vw: () => import('@/assets/icons/car-logos/VolkswagenLogo.vue'),

    default: () => import('@/assets/icons/supportedCars/OthersGreyIcon.vue')
};

export const ADAPTER_TYPE = Object.freeze({
    OBD: 'obd',
    EVO: 'evo',
});

export const EVO_PRICING_PAGE_ROUTE = 'pricing-evo';

export const APP_PAGE_ROUTE = 'app';

export const FAQ_CATEGORY_ID = {
    PRICING_PAGE: 1,
    HOME_PAGE: 2,
    CONTACT_US_PAGE: 3,
    ADAPTERS_PAGE: 4,
    APP_PAGE: 5,
    ABOUT_US: 6,
};

export const TESTIMONIALS_CATEGORY_ID = Object.freeze({
    APP_PAGE: 1,
    ADAPTERS_PAGE: 3,
    HOME_PAGE: 4,
    ABOUT_US_PAGE: 8,
});

export const STORE_LINKS = Object.freeze({
    APP_STORE: 'https://apps.apple.com/us/app/carista-obd2/id954363569',
    GOOGLE_PLAY:
        'https://play.google.com/store/apps/details?id=com.prizmos.carista&hl=en&gl=BG',
    AMAZON: 'https://www.amazon.co.uk/dp/B0CM9W4MCW',
});

export const STORE_ICONS = {
    AMAZON: () => import('@/assets/icons/AmazonIcon.vue'),
    'APP_STORE': () => import('@/assets/icons/AppleLogoIcon.vue'),
    'GOOGLE_PLAY': () => import('@/assets/icons/GooglePlayColorIcon.vue'),
}


export const PAGE_TAGS = Object.freeze([
    'homepage',
    'pricing',
    'adapter',
    'app',
    'features',
    'impressum',
    'web_privacy',
    'web_terms',
    'supported_cars',
    'app_privacy',
    'app_terms',
    'contact_us',
    'adapter_documents',
    'about_us'
]);

export const PAGE_ROUTE_NAMES = Object.freeze({
    home: 'homepage',
    pricing: 'pricing',
    'pricing-evo': 'pricing',
    scanners: 'adapter',
    app: 'app',
    features: 'features',
    impressum: 'impressum',
    'web-privacy': 'web_privacy',
    'web-terms': 'web_terms',
    'supported-cars': 'supported_cars',
    'app-privacy': 'app_privacy',
    'app-terms': 'app_terms',
    'contact-us': 'contact_us',
    'scanner-documents': 'adapter_documents',
    'about-us': 'about_us'
});

export const CAR_ABBREVIATIONS_MAP = Object.freeze({
    vw: 'volkswagen',
    bwm: 'bmw',
    bnw: 'bmw',
    bmv: 'bmw',
});

export const BRANDS_NOT_OBD_SUPPORTED = Object.freeze([
    'buick',
    'cadillac',
    'chevrolet',
    'ford',
    'gmc',
    'holden',
    'hummer',
    'jaguar',
    'land-rover',
    'lincoln',
    'mazda',
    'opelvauxhall',
    'saab',
    'volvo'
]);

export const OBD_PHASEOUT_EXPERIMENT_COUNTRIES = Object.freeze(['DE', 'AT', 'CH', 'IT']);

export const DEFAULT_COUNTRY_CODE = '00';

export const SHOPIFY_BUNDLE_COUNTRIES = Object.freeze(['GB', 'US', 'DE', 'IT', 'ES']);
